import React, { useEffect, useState } from "react";
import { BreakPoints } from "src/const/breakpoint";
import { theme } from "src/theme";

const useCheckMobile = () => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= BreakPoints.md;
  return isMobile;
};
export default useCheckMobile;
